import type { DashboardPeriod } from '~/app/services/organization-manager-dashboard/organization-manager-dashboard.types';
import type { OperatorScorecardStatsDto } from './operator-scorecard.types';

type PeriodSummaryOverride = {
  compliance: number;
  response: number;
  fix: number;
  availability: number;
  urgentSites: number;
};

const PERIOD_SUMMARY: Record<DashboardPeriod, PeriodSummaryOverride> = {
  'q1-2026': {
    compliance: 82,
    response: 1.5,
    fix: 6.2,
    availability: 97.9,
    urgentSites: 3,
  },
  'q2-2026': {
    compliance: 84,
    response: 1.4,
    fix: 6.0,
    availability: 98.2,
    urgentSites: 2,
  },
  'q3-2026': {
    compliance: 86,
    response: 1.3,
    fix: 5.8,
    availability: 98.7,
    urgentSites: 2,
  },
  'q4-2026': {
    compliance: 88,
    response: 1.1,
    fix: 5.2,
    availability: 99.0,
    urgentSites: 1,
  },
  'last-12-months': {
    compliance: 85,
    response: 1.35,
    fix: 5.9,
    availability: 98.4,
    urgentSites: 2,
  },
};

const PERIOD_OPERATOR_PERF: Record<DashboardPeriod, [number, number, number]> =
  {
    'q1-2026': [90, 74, 38],
    'q2-2026': [92, 76, 40],
    'q3-2026': [94, 78, 42],
    'q4-2026': [96, 82, 48],
    'last-12-months': [93, 77, 41],
  };

/**
 * Shapes scorecard mock (or future API payload) for the selected reporting window.
 */
export function applyScorecardPeriod(
  stats: OperatorScorecardStatsDto,
  period: DashboardPeriod,
): OperatorScorecardStatsDto {
  const summary = PERIOD_SUMMARY[period];
  const perf = PERIOD_OPERATOR_PERF[period];

  return {
    ...stats,
    urgentSiteCount: summary.urgentSites,
    summary: {
      overallCompliance: {
        ...stats.summary.overallCompliance,
        score: summary.compliance,
      },
      averageResponseHours: {
        ...stats.summary.averageResponseHours,
        value: summary.response,
      },
      averageFixHours: {
        ...stats.summary.averageFixHours,
        value: summary.fix,
      },
      overallAvailabilityPercent: {
        ...stats.summary.overallAvailabilityPercent,
        value: summary.availability,
      },
    },
    operators: stats.operators.map((operator, index) => ({
      ...operator,
      performancePercent: perf[index] ?? operator.performancePercent,
    })),
  };
}
